<template>
  <div class="yk-stu-manager-new-wrapper clearfix">
    <el-form
      label-width="180px"
      :rules="rules"
      ref="form"
      :model="form"
      class="change-user-password-form"
    >
      <el-form-item label="模拟考试网址网址" prop="KWDUrl">
        <el-input v-model="form.SimulateSystemUrl"></el-input>
      </el-form-item>
      <el-form-item label="大屏数据网址" prop="KWWDUrl">
        <el-input v-model="form.DataSystemUrl"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save('form')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        Id: "",
        SimulateSystemUrl: "",
        DataSystemUrl: ""
      },
      rules: {
        SimulateSystemUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        DataSystemUrl: [{ required: true, message: "请输入", trigger: "blur" }]
      }
    };
  },
  created() {
    this.getFileUrlList();
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  methods: {
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var that = this;
          that.$http
            .post("/api/XOrg/FileManager/addOrEditWebLink", {
              Id: that.form.Id,
              SimulateSystemUrl: that.form.SimulateSystemUrl,
              DataSystemUrl: that.form.DataSystemUrl,
              certificateId:this.certificateId
            })
            .then(function(rst) {
              if (rst.code > 0) {
                that.getFileUrlList();
                that.$message.success(rst.msg);
              } else {
                that.$message.warning(rst.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //查询
    getFileUrlList() {
      var that = this;
      this.$http
        .post("/api/XOrg/FileManager/getFileUrlList",{
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.form = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.yk-stu-manager-new-wrapper {
  padding-top: 50px;
  .change-user-password-form {
    width: 50%;
  }
}
</style>